import { VITE_API_URL } from '@/utils/runtimeConfig';

export const apiUrl = (path: string) => {
  const fallbackUrl =
    typeof window !== 'undefined'
      ? `${window.location.origin}/api/`
      : 'http://localhost:3000/api/';
  const url = new URL(VITE_API_URL || fallbackUrl);
  url.pathname = [url.pathname, path].join('/').replace(/[\\/]+/g, '/');
  return url;
};

export const authUrls = {
  /** `POST` */
  signupStaff: () => apiUrl('/auth/signup.staff'),
  /** `POST` */
  loginStaff: () => apiUrl('/auth/login.staff'),
  /** `POST` */
  signupClient: () => apiUrl('/auth/signup.client'),
  /** `POST` */
  loginClient: () => apiUrl('/auth/login.client'),
  /** `GET` */
  refresh: () => apiUrl('/auth/refresh'),
  /** `GET` */
  getMe: () => apiUrl('/auth/me'),
  /** `GET` */
  getMyPermissions: () => apiUrl('/auth/me.permissions'),
  /** `PUT` */
  updateSecret: () => apiUrl('/auth/update.password'),
  /** `POST` */
  requestOTP: () => apiUrl('/auth/reset.staff'),
};

export const storeUrls = {
  /** `GET` */
  getStore: (storeId: string) => apiUrl(`/restaurants/get/${storeId}`),
  /** `GET` */
  getPickupSlots: (storeId: string) =>
    apiUrl(`/restaurants/${storeId}/schedules/slots`),
};

export const orderUrls = {
  /** `POST` */
  submitOrder: () => apiUrl('/orders/new'),
  /** `PUT` */
  abordOrder: (orderId: string) => apiUrl(`/orders/update/${orderId}/abord`),
  /** `PUT` */
  adjustLines: (orderId: string) => apiUrl(`/orders/update/${orderId}/lines`),
  /** `PUT` */
  changePickupTime: (orderId: string) =>
    apiUrl(`/orders/update/${orderId}/pickup-time`),
  /** `PUT` */
  updateStatus: (orderId: string) => apiUrl(`/orders/update/${orderId}/status`),
  /** `PUT` */
  updateItemsPreparation: (orderId: string) =>
    apiUrl(`/orders/update/${orderId}/items/preparation`),
  /** `GET` */
  getOrderById: (orderId: string) => apiUrl(`/orders/get/${orderId}`),
  /** `GET` */
  orderHistory: (orderId: string) => apiUrl(`/orders/history/${orderId}`),
  /** `GET` */
  getOrderStats: () => apiUrl('/orders/stats'),
  /** `GET` */
  searchOrders: () => apiUrl('/orders/search'),
  /** `POST` */
  addItemInCart: () => apiUrl('/carts/add'),
  /** `PUT` */
  updatecartItem: (itemId: string) => apiUrl(`carts/update/${itemId}`),
  /** `GET` */
  getCartItem: (itemId: string) => apiUrl(`/carts/get/${itemId}`),
  /** `GET` */
  searchCartItems: () => apiUrl('carts/search'),
  /** `DEL` */
  removeCartItem: (itemId: string) => apiUrl(`carts/delete/${itemId}`),
};

export const notificationUrls = {
  /** `GET` */
  getNotifById: (notificationId: string) =>
    apiUrl(`/notifications/get/${notificationId}`),
  /** `GET` */
  searchNotif: () => apiUrl('/notifications/search'),
  /** `PUT` */
  markAsRead: (notificationId: string) =>
    apiUrl(`/notifications/read/${notificationId}`),
  /** `DEL` */
  deleteNotif: (notificationId: string) =>
    apiUrl(`notifications/delete/${notificationId}`),
};
